module.exports = __webpack_public_path__ + "img/EBEquipmentLogo.5c3191c0.png";